import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/terms-of-service";

import { brand } from "@/config/brand";
const SITE_URL = brand.url;
const OG_IMAGE = `${SITE_URL}/__l5e/assets-v1/aabeccab-688e-44b7-96b1-aaf70d6a2a8d/social-share-cover.png`;
const DESC =
  "Digitally Baffled's terms of service. The terms that govern use of our website, mobile app, and the services we provide.";

export const Route = createFileRoute("/terms-of-service")({
  head: () => ({
    meta: [
      { title: "Terms of Service | Digitally Baffled" },
      { name: "description", content: DESC },
      { property: "og:site_name", content: "Digitally Baffled" },
      { property: "og:title", content: "Terms of Service — Digitally Baffled" },
      { property: "og:description", content: DESC },
      { property: "og:url", content: `${SITE_URL}/terms-of-service` },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Terms of Service — Digitally Baffled" },
      { name: "twitter:description", content: DESC },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/terms-of-service` }],
  }),
  component: Page,
});
